module.exports = __webpack_public_path__ + "img/22.3284c6cc.png";